export default __webpack_public_path__ + "static/media/17.00bb5c08.pdf";